import { Container, IconButton, Link, Text } from "@fluidattacks/design";
import type { CellContext } from "@tanstack/react-table";
import { camelCase, isEmpty } from "lodash";
import type { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import type { IStakeholderDataSet } from "../types";
import { InvitationState } from "gql/graphql";

const RoleFormatter = (
  cell: CellContext<IStakeholderDataSet, unknown>,
): JSX.Element => {
  const { t } = useTranslation();
  const role = cell.getValue() as string;
  const baseRolesUrl =
    "https://help.fluidattacks.com/portal/en/kb/articles/understand-roles";

  return isEmpty(role) ? (
    <Text size={"md"}>{"-"}</Text>
  ) : (
    <Link href={`${baseRolesUrl}#Client_roles`} iconPosition={"hidden"}>
      {t(`userModal.roles.${camelCase(role)}`, {
        defaultValue: "-",
      })}
    </Link>
  );
};

const ActionsFormatter = (
  cell: CellContext<IStakeholderDataSet, unknown>,
  loading: boolean,
  resendEmailHandler: (
    stakeholder: IStakeholderDataSet,
  ) => MouseEventHandler<HTMLButtonElement>,
): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { invitationState } = cell.row.original;
  const isPending = invitationState === String(InvitationState.Pending);
  const isDisabled = !isPending || loading;

  return (
    <Container
      alignItems={"center"}
      color={isDisabled ? theme.palette.gray[400] : theme.palette.black}
      display={"flex"}
      gap={0.5}
    >
      <IconButton
        border={`1px solid ${theme.palette.gray[100]} !important`}
        disabled={isDisabled}
        icon={"arrow-rotate-right"}
        iconSize={"sm"}
        iconType={"fa-light"}
        onClick={resendEmailHandler(cell.row.original)}
        variant={"ghost"}
      />
      {t("tables.members.buttons.resend.text")}
    </Container>
  );
};

export { ActionsFormatter, RoleFormatter };
